import { render, staticRenderFns } from "./DirectionSelector.vue?vue&type=template&id=15f6d1b2&"
import script from "./DirectionSelector.vue?vue&type=script&lang=js&"
export * from "./DirectionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports